import React from 'react';
import { Layout, Title } from 'app/blocks/blocks';
import { getQueryParamSafe } from 'app/blocks/common/utils';
import * as middleware from 'app/blocks/middleware/middleware';
import { OpenAccessOrderStepEnum } from 'app/pages/orders/oa';
import { navigate } from 'app/route/history';

export default class OrderConfirmationHandler extends React.PureComponent {
    componentDidMount() {
        if (this.props.oa) {
            this.openaccessconfirmation();
        }
    }

    url() {
        return this.props.url || window.location.href;
    }

    openaccessconfirmation() {
        this.orderconfirmation(
            middleware.openaccess.getOrder,
            middleware.openaccess.submitOrder,
            (action, order, error) => {
                navigate(`/orders/${order.article.id}?action=${action}&type=openaccess`, undefined, { order, error });
            },
        );
    }

    async orderconfirmation(getOrder, submitOrder, openItem) {
        const openedUrl = this.url();
        const params = getQueryParamSafe(openedUrl);
        try {
            const order = await getOrder(
                params.articleId,
                params.correlationId,
                params.ooUniqueId, // not exist for OA
            );
            if (params.code === 'SUCCESS') {
                try {
                    await submitOrder(order);
                    openItem(OpenAccessOrderStepEnum.CONFIRMATION, order);
                } catch (error) {
                    openItem(OpenAccessOrderStepEnum.REVIEW, order, error);
                }
            } else if (params.code || params.message) {
                openItem(OpenAccessOrderStepEnum.REVIEW, order, {
                    code: params.code,
                    refId: params.refId,
                    message: params.message && decodeURIComponent(params.message.replace(/\+/g, '%20')),
                });
            } else {
                openItem(OpenAccessOrderStepEnum.REVIEW, order);
            }
        } catch (error) {
            navigate('/orders', undefined, { error });
        }
    }

    render() {
        return (
            <div className="container">
                <Title>{this.props.title}</Title>
                <Layout isLoading />
            </div>
        );
    }
}
